import axios from "axios";

const API_URL = "https://api.ipk-test.com.ua/api/V1/food/order/";
export const fetchOrders = async () => {
  try {
    const response = await axios.post(API_URL, {
        action: 'list',
        food_service_id: '9e80b8d5-4d90-4dd7-8d37-60119a47ba51'
      });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Помилка отримання замовлень:", error);
    return [];
  }
};